import { useTranslation } from 'react-i18next';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import Modal, {
  ModalType
} from '../../../../../../../../../../../common/components/modal/Modal';
import AlertIcon from './icons/AlertIcon';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isDeleting
}) => {
  const { t } = useTranslation(['events']);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      type={ModalType.SMALL}
      visible={isOpen}
      autoHeight
      title={t('events:pricingTiers.categories.deleteModal.title')}
      icon={
        <AlertIcon />
      }
      iconVariant="danger"
      onClose={onCancel}
    >
      <div className="p-6 pb-0">
        <div className="text-left mb-6 text-base font-normal text-[#575757]">
          <p>{t('events:pricingTiers.categories.deleteModal.line1')}</p>
          <p>{t('events:pricingTiers.categories.deleteModal.line2')}</p>
          <p>{t('events:pricingTiers.categories.deleteModal.line3')}</p>
        </div>

        <div className="flex justify-center space-x-4 w-full">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="py-2 px-8 rounded-full bg-[#EFF2FF] text-[#3853C4] font-medium hover:bg-[#e0e5ff] transition-colors w-full"
          >
            {t('events:pricingTiers.categories.deleteModal.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="py-2 px-8 rounded-full bg-[#A4332A] text-white font-medium hover:bg-[#8a2b24] transition-colors w-full"
          >
            {isDeleting ? (
              <AiOutlineLoading3Quarters
                size={20}
                className="animate-spin mx-auto"
              />
            ) : (
              t('events:pricingTiers.categories.deleteModal.delete')
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
